/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Apa_S1Inputs */

const en_mk_tut_apa_s1 = /** @type {(inputs: Mk_Tut_Apa_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**An issue** is one accountable piece of work — it has a title, a status, a priority and one assignee. That assignee can be a person or an agent.`)
};

const id_mk_tut_apa_s1 = /** @type {(inputs: Mk_Tut_Apa_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**Issue** adalah satu pekerjaan yang bisa dipertanggungjawabkan — punya judul, status, prioritas, dan satu penanggung jawab. Penanggung jawabnya boleh manusia, boleh agen.`)
};

/**
* | output |
* | --- |
* | "**An issue** is one accountable piece of work — it has a title, a status, a priority and one assignee. That assignee can be a person or an agent." |
*
* @param {Mk_Tut_Apa_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_apa_s1 = /** @type {((inputs?: Mk_Tut_Apa_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Apa_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_apa_s1(inputs)
	return en_mk_tut_apa_s1(inputs)
});